import { c as _c } from "react/compiler-runtime";
import type { NFTWithMemesExtendedData } from "@/entities/INFT";
import { getDimensionsFromMetadata, getFileTypeFromMetadata } from "@/helpers/nft.helpers";
import NowMintingCountdown from "./NowMintingCountdown";
import NowMintingDetailsAccordion from "./NowMintingDetailsAccordion";
import NowMintingHeader from "./NowMintingHeader";
import NowMintingStatsGrid from "./NowMintingStatsGrid";
interface NowMintingDetailsProps {
  readonly nft: NFTWithMemesExtendedData;
}
export default function NowMintingDetails(t0) {
  const $ = _c(25);
  const {
    nft
  } = t0;
  const formatEth = _temp;
  let t1;
  if ($[0] !== nft.artist || $[1] !== nft.artist_seize_handle || $[2] !== nft.id || $[3] !== nft.name) {
    t1 = <NowMintingHeader cardNumber={nft.id} title={nft.name} artistHandle={nft.artist_seize_handle} artistName={nft.artist} />;
    $[0] = nft.artist;
    $[1] = nft.artist_seize_handle;
    $[2] = nft.id;
    $[3] = nft.name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = nft.id;
  const t3 = formatEth(nft.floor_price);
  let t4;
  if ($[5] !== nft.id || $[6] !== t3) {
    t4 = <NowMintingStatsGrid nftId={t2} floorPrice={t3} />;
    $[5] = nft.id;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = nft.mint_date;
  let t6;
  if ($[8] !== nft.metadata) {
    t6 = getFileTypeFromMetadata(nft.metadata);
    $[8] = nft.metadata;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== nft.metadata) {
    t7 = getDimensionsFromMetadata(nft.metadata);
    $[10] = nft.metadata;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== nft.collection || $[13] !== nft.mint_date || $[14] !== nft.season || $[15] !== t6 || $[16] !== t7) {
    t8 = <NowMintingDetailsAccordion mintDate={t5} fileType={t6} dimensions={t7} collection={nft.collection} season={nft.season} />;
    $[12] = nft.collection;
    $[13] = nft.mint_date;
    $[14] = nft.season;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== nft.id) {
    t9 = <NowMintingCountdown nftId={nft.id} />;
    $[18] = nft.id;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t4 || $[22] !== t8 || $[23] !== t9) {
    t10 = <div className="tw-w-full"><div className="tw-flex tw-flex-col tw-gap-6">{t1}{t4}{t8}{t9}</div></div>;
    $[20] = t1;
    $[21] = t4;
    $[22] = t8;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}
function _temp(value) {
  if (value === 0) {
    return "0 ETH";
  }
  return `${value.toFixed(5)} ETH`;
}